export default __webpack_public_path__ + "locales/pl/PaymentsEnterprise.json?hash=241c6323a96c1c001ba8ade7c5cf1d15";